import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { chipset, model, fwtype, fw, pkgtype, pkg, priority, fwfile, release, app, pincode, user, role, fwrs, apprs } from '../types/types'


export const useRSStore = defineStore('ReleaseSystem', () => {

  const chipsetList = ref<chipset[]>([])
  const modelList = ref<model[]>([])
  const fwtypeList = ref<fwtype[]>([])
  const fwList = ref<fw[]>([])
  const pkgtypeList = ref<pkgtype[]>([])
  const pkgList = ref<pkg[]>([])
  const priorityList = ref<priority[]>([])
  const fwFileList = ref<fwfile[]>([])
  const releaseList = ref<release[]>([])
  const releaseItem = ref<release>()
  const appList = ref<app[]>([])
  const userList = ref<user[]>([])
  const roleList = ref<role[]>([])
  const pincode = ref<pincode>();
  const nextunit = ref(9)   // 페이지네이션 이동범위
  const fwrsList = ref<fwrs[]>([])
  const apprsList = ref<apprs[]>([])

  return {
    chipsetList,
    modelList,
    fwtypeList,
    fwList,
    pkgtypeList,
    pkgList,
    priorityList,
    fwFileList,
    releaseList,
    releaseItem,
    appList,
    userList,
    roleList, 
    pincode,
    nextunit,
    fwrsList,
    apprsList
  }
})